import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import {
  EMAIL_REGEX,
  INPUT_LENGTH_15,
  PHONE_NO_LENGTH,
  ROLE,
  SWAL_SETTINGS,
  TEXTAREA_MAX_LENGTH,
} from "../../../../utils/Constants";
import {
  blockInvalidChar,
  DT,
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { Details, Edit } from "../../services/doctor.services";
import { GetAllCenters } from "../../services/usermgmt.services";
import { cuisineOptions } from "../../../../utils/Constants";
import { TagPicker, Tooltip, Whisper } from "rsuite";
import PhoneInput from "../../../../utils/PhoneInput";
import { PHONE_VALIDATION } from "../../../../utils/commonValidations";
import trash from "../../../../assets/center/images/trash.svg";
import { ACTIVE, DEACTIVE, DOCTOR_SPECIALIZATION, GENDER, LOADER_TIMEOUT_TIME, SORT_A, SORT_D } from "../../../../utils/Constants";
import { capitalizeFirstLetter, formatDateFromTime, formatePickerDate, getColorType, getDateWithTime, getDayDiff, handleOffcanvasScroll, TrimText, useDebouncing } from "../../../../utils/commonfunction";
import { CATEGORIES_TAX_TYPES } from "../../../../utils/Constants";
import { ReactSortable } from "react-sortablejs";
import { Link, useLocation, useParams } from "react-router-dom";
import { DatePicker, Drawer } from "rsuite";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../../admin/common/custompagination";
import DefaultProfileImg from '../../../../assets/center/images/default_user_profile.png';
import { SpecializationList } from "../../services/coach-specialization.services";
import pdfImage from "../../../../assets/center/images/pdf.png"
import excelImage from "../../../../assets/center/images/excel.png"
import wordImage from "../../../../assets/center/images/documnet.png"
import pptImage from "../../../../assets/center/images/PowerPoint.png"
import Select from 'react-select';


const UserEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [previewimage, setPreviewImage] = useState("");
  const [saveType, setSaveType] = useState("");
  const [centers, setCenters] = useState([]);
  const fileSelectInput = useRef();
  const [specialization, setSpecialization] = useState([]);
  const [previewDocument, setPreviewDocument] = useState("");

  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: t("Doctor Management"),
      url: "/admin/doctor-management/doctor/list/1",
    },
    { title: t("admin.cafes.link_edit"), url: "" },
  ];

  useEffect(() => {
    GetAllCenters()
      .then((data) => {
        setCenters(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  }, []);

  useEffect(() => {
    SpecializationList(ROLE.SUPER_ADMIN)
      .then((data) => {
        setSpecialization(data && data.data ? data.data.list : []);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  }, []);

  useEffect(() => {
    Details(params.id, ROLE.SUPER_ADMIN)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : {});
        setPreviewDocument(response?.data.document);
        // console.log("response.data", response.data);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  const handleFilePreview = (file) => {
    if (typeof file === "string") {
      return file;
    } else {
      return URL.createObjectURL(file);
    }
  };

  const handleFileSelection = (event, form) => {
    if (event.target.files.length) {
      form.setFieldValue("profile_image", event.target.files[0]);
    }
  };

  const handleStartTimeChange = (e) => {
    editForm.setFieldTouched('startTime', true);
    const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
    if (match && match[0]) {
      const parts = match[0].split(':');
      const hours = parts[0];
      const minutes = parts[1];
      const seconds = parts[2] || '00';
      editForm.setFieldValue('startTime', `${hours}:${minutes}:${seconds}`);
    }
  };

  const handleEndTimeChange = (e) => {
    editForm.setFieldTouched('endTime', true);
    const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
    if (match && match[0]) {
      const parts = match[0].split(':');
      const hours = parts[0];
      const minutes = parts[1];
      const seconds = parts[2] || '00';
      editForm.setFieldValue('endTime', `${hours}:${minutes}:${seconds}`);
    }
  };

  const validationSchema = Yup.object().shape({
    first_name: Yup.string().trim().max(50, "First name name must not be more than 50 characters.").required("First name is required"),
    last_name: Yup.string().trim().max(50, "Last name name must not be more than 50 characters.").required("Last name is required"),
    email: Yup.string()
      .trim()
      .required("admin.cafes.label_email_required_error")
      .email("admin.cafes.label_email_invalid_format_error")
      .matches(
        /^(?!\.)(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "admin.cafes.label_email_invalid_format_error"
      ),
    gender: Yup.string()
      .trim()
      .required("Gender is required"),
    consultation_charge: Yup.number()
      .required("Consultation charge is required")
      .integer("Consultation charge must be an integer")
      .min(0, "Consultation charge cannot be negative")
      .max(9999, "Consultation charge cannot be more than 4 digits"),
    experience_years: Yup.number()
      .required("Experience(years) is required")
      .integer("Experience(years) must be an integer")
      .min(0, "Experience(years) cannot be negative")
      .max(9999, "Experience(years) cannot be more than 4 digits"),
    experience_months: Yup.number()
      .required("Experience(months) is required")
      .integer("Experience(months) must be an integer")
      .min(0, "Experience(months) cannot be negative")
      .max(9999, "Experience(months) cannot be more than 4 digits"),
    dob: Yup.string().required("DOB is required"),
    specialization: Yup.mixed()
      .required("Specialization is required")
      .test("no-spaces", "Specialization is required", (value) => {
        return String(value).trim().length > 0;
      }),
    center: Yup.string()
      .trim()
      .required("Centre is required"),
    startTime: Yup.string()
      .trim()
      .required("Start time is required"),
    endTime: Yup.string()
      .trim()
      .required("End time is required")
      .test('is-greater-than-startTime', 'End time must be greater than start time', function (value) {
        const { startTime } = this.parent;

        const start = new Date(`1970-01-01T${startTime}`);
        const end = new Date(`1970-01-01T${value}`);
        return start <= end;
      }),
    phone_number: PHONE_VALIDATION,
    // address: Yup.string().trim().max(TEXTAREA_MAX_LENGTH, "Location must not be more than 150 characters.").required("Location is required"),
    // profile_image: Yup.mixed()
    //   .nullable()
    //   .test(
    //     'fileType',
    //     'admin.cafes.supported_file_error',
    //     value => !value || ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(value.type)
    //   )
    //   .test(
    //     'fileSize',
    //     'admin.cafes.image_max_size_error',
    //     value => !value || value.size <= 1.5 * 1024 * 1024
    //   )
    //   .test(
    //     'validImage',
    //     'Upload a valid image',
    //     value =>
    //       new Promise(resolve => {
    //         if (!value || typeof value === 'string') return resolve(true);

    //         const reader = new FileReader();
    //         reader.onload = () => {
    //           const img = new Image();
    //           img.onload = () => resolve(true);
    //           img.onerror = () => resolve(false);
    //           img.src = reader.result;
    //         };
    //         reader.onerror = () => resolve(false);
    //         reader.readAsDataURL(value);
    //       })
    //   ),
    profile_image: Yup.mixed()
      .nullable()
      .test(
        'fileOrUrl',
        'admin.cafes.supported_file_error',
        value => {
          if (!value) return true;
          if (typeof value === 'string') return /^(http|https):\/\/[^\s$.?#].[^\s]*$/gm.test(value);
          return ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(value.type);
        }
      )
      .test(
        'fileSize',
        'admin.cafes.image_max_size_error',
        value => {
          if (!value || typeof value === 'string') return true;
          return value.size <= 1.5 * 1024 * 1024;
        }
      )
      .test(
        'validImage',
        'Upload a valid image',
        value =>
          new Promise(resolve => {
            if (!value || typeof value === 'string') return resolve(true);

            const reader = new FileReader();
            reader.onload = () => {
              const img = new Image();
              img.onload = () => resolve(true);
              img.onerror = () => resolve(false);
              img.src = reader.result;
            };
            reader.onerror = () => resolve(false);
            reader.readAsDataURL(value);
          })
      ),

    // document: Yup.mixed()
    // .nullable()
    // .test(
    //   'fileOrUrl',
    //   'File not supported',
    //   value => {
    //     if (!value) return true;
    //     if (typeof value === 'string') return /^(http|https):\/\/[^\s$.?#].[^\s]*$/gm.test(value);
    //     return ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(value.type);
    //   }
    // )
    // .test(
    //   'fileSize',
    //   'admin.cafes.image_max_size_error',
    //   value => {
    //     if (!value || typeof value === 'string') return true;
    //     return value.size <= 1.5 * 1024 * 1024;
    //   }
    // )
  });

  const specializationData = specialization.map((item) => ({
    label: capitalizeFirstLetter(item?.title),
    value: item?._id,
  }));



  const editForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      profile_image: showdefault && showdefault.profile_image ? showdefault.profile_image : "",
      document: showdefault && showdefault.document ? showdefault.document : "",
      first_name: showdefault && showdefault.first_name ? showdefault.first_name : "",
      last_name: showdefault && showdefault.last_name ? showdefault.last_name : "",
      email: showdefault && showdefault.email ? showdefault.email : "",
      dob: showdefault && showdefault.dob ? showdefault.dob : "",
      gender: showdefault && showdefault.gender ? showdefault.gender : "",
      specialization: showdefault && showdefault.specialisation ? showdefault.specialisation : [],
      phone_number: showdefault && showdefault.phone_number ? showdefault.phone_number : "",
      center: showdefault && showdefault.centers ? showdefault.centers[0].center_id : "",
      startTime: showdefault && showdefault.centers ? showdefault.centers[0].start_available_time : "",
      endTime: showdefault && showdefault.centers ? showdefault.centers[0].end_available_time : "",
      consultation_charge: showdefault && showdefault.consultation_charge ? showdefault.consultation_charge : "",
      experience_months: showdefault && showdefault.experience_months ? showdefault.experience_months : "",
      experience_years: showdefault && showdefault.experience_years ? showdefault.experience_years : "",
      qualification1: showdefault && showdefault.qualification1 ? showdefault.qualification1 : "",
      qualification2: showdefault && showdefault.qualification2 ? showdefault.qualification2 : "",
      institute1: showdefault && showdefault.institute1 ? showdefault.institute1 : "",
      institute2: showdefault && showdefault.institute2 ? showdefault.institute2 : "",
    },
    validateOnBlur: false,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      setSubmitted(true);
      let formData = new FormData();
      formData.append("o_id", showdefault._id);
      formData.append("first_name", values.first_name);
      formData.append("last_name", values.last_name);
      formData.append("email", values.email);
      formData.append("phone_number", values.phone_number);
      formData.append("dob", values.dob);
      formData.append("gender", values.gender);
      formData.append("specialisation", JSON.stringify(values.specialization));
      formData.append("center_id", values.center);
      formData.append("start_available_time", values.startTime);
      formData.append("end_available_time", values.endTime);
      if (values.profile_image) {
        formData.append("profile_image", values.profile_image);
      }
      if (values.document) {
        formData.append("document", values.document);
      }
      formData.append("consultation_charge", values.consultation_charge);
      formData.append("experience_months", values.experience_months);
      formData.append("experience_years", values.experience_years);
      formData.append("qualification1", values.qualification1);
      formData.append("qualification2", values.qualification2);
      formData.append("institute1", values.institute1);
      formData.append("institute2", values.institute2);

      Edit(formData, ROLE.SUPER_ADMIN)
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            resetForm({ values: "" });
            navigate(`/admin/doctor-management/doctor/list/1`);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            setSubmitted(false);
          }
        })
        .catch((error) => {
          console.log("error ====> ", error);
        });
    },
  });

    const centerOptions = centers.map((item) => ({
      value: item._id,
      label: `${capitalizeFirstLetter(item.center_name)}${item.city ? ` (${capitalizeFirstLetter(item.city)})` : ''}`
    }));


  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={editForm.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div className="row row-sm">
                  <div className="profile-photo-upload mb-3" style={{ margin: "auto" }}>
                    <div
                      className="avatar avatar-xl"
                      onClick={() => fileSelectInput?.current?.click()}
                      style={{
                        position: "relative",
                        width: "100px",
                        height: "100px",
                        overflow: "hidden",
                        borderRadius: "50%",
                        border: "1px solid rgb(175, 177, 178)",
                      }}
                    >
                      <img
                        alt="profile_image"
                        src={editForm?.values?.profile_image ? handleFilePreview(editForm?.values?.profile_image) : DefaultProfileImg}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />

                      {/* Upload Icon */}
                      <div
                        style={{
                          position: "absolute",
                          bottom: "2px",
                          right: "33px",
                          backgroundColor: "#fff",
                          borderRadius: "50%",
                          padding: "5px",
                          cursor: "pointer",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                          width: "35px",
                          height: "30px"
                        }}
                      >
                        <i className="ti ti-upload d-flex justify-content-center" style={{ fontSize: "20px", height: "10px", color: "#007bff" }}></i>
                      </div>
                    </div>

                    {/* Hidden file input */}
                    <button className="cp e_none" type="button" style={{ display: "none" }}>
                      <input
                        ref={fileSelectInput}
                        id="profile_image"
                        name="profile_image"
                        accept="image/*"
                        type="file"
                        onChange={(e) => handleFileSelection(e, editForm)}
                      />
                    </button>
                  </div>


                  <CustomError name="profile_image" form={editForm} className="text-danger text-left d-flex my-3" />
                  {/* {console.log(editForm.errors)} */}
                  {/* first name */}
                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("center.staff.label_first_name")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      id="name"
                      type="text"
                      placeholder={t("center.staff.placeholder_first_name")}
                      name="first_name"
                      value={editForm?.values?.first_name}
                      onChange={editForm.handleChange}
                      onBlur={editForm.handleBlur}
                      className="form-control"
                    />
                    <span className="text-danger d-flex text-left">
                      {/* <CustomError shortCodes={[INPUT_LENGTH_15]} name="name" form={formik} /> */}
                      <CustomError name="first_name" form={editForm} className="text-danger" />
                    </span>
                  </div>

                  {/* last name */}
                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("center.staff.label_last_name")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      id="name"
                      type="text"
                      placeholder={t("center.staff.placeholder_last_name")}
                      name="last_name"
                      value={editForm?.values?.last_name}
                      onChange={editForm.handleChange}
                      onBlur={editForm.handleBlur}
                      className="form-control"
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="last_name" form={editForm} className="text-danger" />
                    </span>
                  </div>

                  {/* email */}
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("center.staff.label_email")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder={t("center.staff.placeholder_email_address")}
                      name="email"
                      value={editForm?.values?.email}
                      onChange={editForm.handleChange}
                      onBlur={editForm.handleBlur}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="email" form={editForm} className="text-danger" />
                    </span>
                  </div>

                  {/* Phone Number */}
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Phone Number:
                      <span className="requirestar">*</span>
                    </label>
                    <PhoneInput
                      value={editForm?.values?.phone_number}
                      name={"phone_number"}
                      onChange={(e) => {
                        editForm.setFieldValue("phone_number", e?.phone_number);
                      }}
                      placeholder={t("center.staff.placeholder_contact_number")}
                      onBlur={editForm.handleBlur}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="phone_number" form={editForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                    </span>
                  </div>
                  {/* gender  */}
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Gender")}:
                      <span className="requirestar">*</span>
                    </label>
                    <select className="form-control form-select cp" name='gender' value={editForm?.values?.gender} onChange={editForm.handleChange}>
                      <option value={""}>{t("Select")}</option>
                      {GENDER.map((item, index) => { return (<option key={index} value={item.value}>{item.label}</option>) })}
                    </select>
                    {editForm.touched.gender && editForm.errors.gender ? (
                      <div className="text-danger d-flex text-left">{t(editForm.errors.gender)}</div>
                    ) : null}
                  </div>
                  {/* dob */}
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("DOB")}:
                      <span className="requirestar">*</span>
                    </label>
                    <DatePicker
                      oneTap={true}
                      editable={false}
                      classPrefix="restaurant"
                      placeholder={t("Enter DOB")}
                      placement="autoVertical"
                      format="dd.MM.yyyy"
                      cleanable={false}
                      name="dob"
                      onChange={(e) => {
                        editForm.setFieldTouched('dob', true);
                        editForm.setFieldValue("dob", e);
                      }}
                      value={new Date(editForm.values.dob) || new Date()}
                      onBlur={editForm.handleBlur}
                      shouldDisableDate={(date) => {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        const minDate = new Date();
                        minDate.setFullYear(today.getFullYear() - 18);
                        minDate.setHours(0, 0, 0, 0);

                        return date >= minDate;
                      }}
                      onOpen={() => {
                        if (!editForm.values.dob) {
                          const today = new Date();
                          const minDate = new Date();
                          minDate.setFullYear(today.getFullYear() - 18);

                          editForm.setFieldValue("dob", minDate);
                        }
                      }}
                    />

                    <CustomError name="dob" form={editForm} className="text-danger d-flex text-left" />
                  </div>
                  {/* specialization */}
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Specialization")}:
                      <span className="requirestar">*</span>
                    </label>
                    {/* <select className="form-control form-select cp" name='specialization' value={editForm?.values?.specialization} onChange={editForm.handleChange}>
                      <option value={""}>{t("Select")}</option>
                      {DOCTOR_SPECIALIZATION.map((item, index) => { return (<option key={index} value={item.value}>{item.label}</option>) })}
                    </select> */}
                    {/* {console.log("editForm.values.specialization", editForm.values.specialization)} */}
                    <TagPicker
                      data={specializationData}
                      defaultValue={editForm.values.specialization}
                      className="w-100 rsuite-input"
                      onChange={(e) => editForm.setFieldValue("specialization", e)}
                      cleanable={false}
                      value={editForm.values.specialization}
                    />
                    {editForm.touched.specialization && editForm.errors.specialization ? (
                      <div className="text-danger d-flex text-left">{t(editForm.errors.specialization)}</div>
                    ) : null}
                  </div>
                  {/* Centers */}
                  {/* <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Center
                      <span className="requirestar">*</span>
                    </label>
                    <select className="form-control form-select cp" name='center' value={editForm?.values?.center} onChange={editForm.handleChange}>
                      <option value={""}>{t("Select")}</option>
                      {centers.map((item, index) => { return (<option key={index} value={item._id}>{capitalizeFirstLetter(item.center_name)}{item.city ? ` (${capitalizeFirstLetter(item.city)})` : ''}</option>) })}
                    </select>
                    {editForm.touched.center && editForm.errors.center ? (
                      <div className="text-danger d-flex text-left">{t(editForm.errors.center)}</div>
                    ) : null}
                  </div> */}
                   <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Center:
                      <span className="requirestar">*</span>
                    </label>

                    <Select
                      className="cp"
                      name="center"
                      options={centerOptions}
                      value={centerOptions.find(option => option.value === editForm.values.center)}
                      onChange={selectedOption => editForm.setFieldValue('center', selectedOption?.value)}
                      onBlur={() => editForm.setFieldTouched('center', true)}
                      placeholder={t("Select")}
                      isSearchable={true}
                      noOptionsMessage={() => t("No centers found")}
                    />

                    {editForm.touched.center && editForm.errors.center ? (
                      <div className="text-danger d-flex text-left">{t(editForm.errors.center)}</div>
                    ) : null}
                  </div>
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Consultation Charge")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder={t("Enter consultation charge")}
                      name="consultation_charge"
                      value={editForm?.values?.consultation_charge}
                      onChange={editForm.handleChange}
                      onBlur={editForm.handleBlur}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="consultation_charge" form={editForm} className="text-danger" />
                    </span>
                  </div>
                  <div className="col-lg-3 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Experience(Years)")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder={t("Enter experience(years)")}
                      name="experience_years"
                      value={editForm?.values?.experience_years}
                      onChange={editForm.handleChange}
                      onBlur={editForm.handleBlur}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="experience_years" form={editForm} className="text-danger" />
                    </span>
                  </div>
                  <div className="col-lg-3 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Experience(Months)")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder={t("Enter experience(months)")}
                      name="experience_months"
                      value={editForm?.values?.experience_months}
                      onChange={editForm.handleChange}
                      onBlur={editForm.handleBlur}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="experience_months" form={editForm} className="text-danger" />
                    </span>
                  </div>
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Qualification 1")}:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Enter qualification 1")}
                      name="qualification1"
                      value={editForm?.values?.qualification1}
                      onChange={editForm.handleChange}
                      onBlur={editForm.handleBlur}
                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError name="experience" form={editForm} className="text-danger" />
                    </span> */}
                  </div>
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Institute 1")}:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Enter institute 1")}
                      name="institute1"
                      value={editForm?.values?.institute1}
                      onChange={editForm.handleChange}
                      onBlur={editForm.handleBlur}
                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError name="experience" form={editForm} className="text-danger" />
                    </span> */}
                  </div>
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Qualification 2")}:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Enter qualification 2")}
                      name="qualification2"
                      value={editForm?.values?.qualification2}
                      onChange={editForm.handleChange}
                      onBlur={editForm.handleBlur}
                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError name="experience" form={editForm} className="text-danger" />
                    </span> */}
                  </div>
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Institute 2")}:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Enter institute 2")}
                      name="institute2"
                      value={editForm?.values?.institute2}
                      onChange={editForm.handleChange}
                      onBlur={editForm.handleBlur}
                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError name="experience" form={editForm} className="text-danger" />
                    </span> */}
                  </div>
                  {/* timing */}
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-12">
                      </div>
                      <div className="col-md-6">
                        <label className="text-left d-flex">
                          Start Time:
                          <span className="requirestar">*</span>
                        </label>
                        <div className="mb-3">
                          <DatePicker
                            classPrefix="restaurant"
                            placement="autoVertical"
                            format="HH:mm"
                            cleanable={false}
                            editable={true}
                            name="openingTime"
                            onChange={handleStartTimeChange}
                            value={getDateWithTime(editForm.values.startTime)}
                            onBlur={editForm.handleBlur}
                            hideMinutes={(minute) => minute % 15 !== 0}
                          />
                          <CustomError name="startTime" form={editForm} className="text-danger d-flex text-left" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="text-left d-flex">
                          End Time:
                          <span className="requirestar">*</span>
                        </label>
                        <div className="mb-3">
                          <DatePicker
                            classPrefix="restaurant"
                            placement="autoVertical"
                            format="HH:mm"
                            cleanable={false}
                            editable={true}
                            name="closingTime"
                            onChange={handleEndTimeChange}
                            value={getDateWithTime(editForm.values.endTime)}
                            hideMinutes={(minute) => minute % 15 !== 0}
                          />
                          <CustomError name="endTime" form={editForm} className="text-danger d-flex text-left" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 text-center form-group"></div>
                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="document" className="text-left d-flex">
                      {t("Reupload Document")}:
                      {" "}
                      {/* <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            {t("Reupload document")}
                          </Tooltip>
                        }
                      >
                        <span className="field-more-info mt-1 ms-1 cp">
                          ?
                        </span>
                      </Whisper> */}
                    </label>
                    <input
                      className="form-control imgInput"
                      id="document"
                      name="document"
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.rtf,.odt,.ppt,.pptx"
                      type="file"
                      onChange={(event) => {
                        editForm.setFieldValue(
                          "document",
                          event.target.files[0] || ""
                        );
                      }}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="document" form={editForm} />
                    </span>
                    {previewDocument && (
                      <ul className="question-image-preview questions-ul">
                        <li className="pr_img_box">
                          {/* Image Files */}
                          {/\.(jpg|jpeg|png|gif)$/i.test(previewDocument) ? (
                            <img
                              src={previewDocument}
                              style={{ height: "100px" }}
                              alt="Image Preview"
                            />
                          ) :
                            // PDF Files
                            /\.(pdf)$/i.test(previewDocument) ? (
                              <a href={previewDocument} download target="_blank" rel="noopener noreferrer">
                                <img
                                  src={pdfImage}
                                  alt="PDF File"
                                  style={{ height: "100px", cursor: "pointer" }}
                                />
                              </a>
                            ) :
                              // Excel Files
                              /\.(xlsx|xls)$/i.test(previewDocument) ? (
                                <a href={previewDocument} download target="_blank" rel="noopener noreferrer">
                                  <img
                                    src={excelImage}
                                    alt="Excel File"
                                    style={{ height: "100px", cursor: "pointer" }}
                                  />
                                </a>
                              ) :
                                // Word Files
                                /\.(doc|docx|odt)$/i.test(previewDocument) ? (
                                  <a href={previewDocument} download target="_blank" rel="noopener noreferrer">
                                    <img
                                      src={wordImage}
                                      alt="Word File"
                                      style={{ height: "100px", cursor: "pointer" }}
                                    />
                                  </a>
                                ) :
                                // PowerPoint Files
                                    /\.(ppt|pptx)$/i.test(previewDocument) ? (
                                      <a href={previewDocument} download target="_blank" rel="noopener noreferrer">
                                        <img
                                          src={pptImage}
                                          alt="PowerPoint File"
                                          style={{ height: "100px", cursor: "pointer" }}
                                        />
                                      </a>
                                    ) : (
                                      <p>Unsupported file type</p>
                                    )}
                        </li>
                      </ul>
                    )}
                  </div>
                  <div>
                    {editForm?.values?.document && typeof editForm?.values?.document === "string" ?
                      editForm?.values?.document?.split('/')?.pop()
                      : ""
                    }
                  </div>

                  {/* submission buttons */}
                  <div className="mt-5">
                    <button
                      className="btn btn-info mr-2"
                      type="submit"
                      disabled={submitted ? true : null}
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("admin.button.btn_submit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      disabled={submitted ? true : null}
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("admin.button.btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default UserEdit;